
import Logout from "../../../assets/duotone/Logout.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LogoutIcon({ className, dataTestid = "LogoutIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Logout data-testid={dataTestid} className={classes} {...rest} />
  );
}
